// src/pages/Customer/Checkout/CheckoutSuccess.tsx
import React from "react";
import { useLocation, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";

/* --------- küçük tema yardımcıları (surface & divider) --------- */
const hexToRgb = (hex: string) => {
  const h = (hex || "#0f1115").replace("#", "");
  const full = h.length === 3 ? h.split("").map(c => c + c).join("") : h;
  const n = parseInt(full, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
};
const luminance = ({ r, g, b }: { r: number; g: number; b: number }) => {
  const f = (v: number) => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
  return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
};
const useSurfaces = (theme?: any) => {
  const bg = theme?.backgroundColor || "#0f1115";
  const isDark = luminance(hexToRgb(bg)) < 0.5;
  return {
    bg,
    surface1: isDark ? "rgba(255,255,255,.05)" : "#ffffff",
    divider:  isDark ? "rgba(255,255,255,.12)" : "#e5e7eb",
    textPrimary: theme?.textPrimary ?? (isDark ? "#ffffff" : "#111827"),
    textSecondary: theme?.textSecondary ?? (isDark ? "rgba(255,255,255,.75)" : "#6b7280"),
    accent: theme?.accent ?? "#22c55e",
  };
};

const useQuery = () => new URLSearchParams(useLocation().search);

const CheckoutSuccess: React.FC = () => {
  const q = useQuery();
  const no = q.get("no");
  const id = q.get("id");
  const { theme } = useTheme();
  const S = useSurfaces(theme);

  return (
    <div
      className="min-h-[60vh] grid place-items-center px-4 py-10"
      style={{ backgroundColor: S.bg }}
    >
      <div
        className="w-full max-w-lg rounded-2xl p-6 border text-center shadow-sm"
        style={{ background: S.surface1, borderColor: S.divider }}
      >
        <CheckCircle2 size={48} className="mx-auto mb-3" color={S.accent} />
        <h1 className="text-xl font-semibold mb-1" style={{ color: S.textPrimary }}>
          Siparişiniz alındı
        </h1>

        {no ? (
          <div className="text-sm mb-4" style={{ color: S.textSecondary }}>
            Sipariş No: <b style={{ color: S.textPrimary }}>{no}</b>
          </div>
        ) : (
          <div className="text-sm mb-4" style={{ color: S.textSecondary }}>
            Sipariş bilgileriniz başarıyla oluşturuldu.
          </div>
        )}

        <div className="flex flex-col gap-2">
          <Link
            to="/musteri/panel/siparisler"
            className="h-11 rounded-md text-white grid place-items-center"
            style={{ background: S.accent }}
          >
            Siparişlerime Git
          </Link>

          {id && (
            <Link
              to={`/musteri/panel/siparisler/${id}`}
              className="h-11 rounded-md border grid place-items-center"
              style={{ borderColor: S.divider, color: S.textPrimary, background: "transparent" }}
            >
              Bu Siparişin Detayı
            </Link>
          )}

          <Link
            to="/"
            className="h-11 rounded-md border grid place-items-center"
            style={{ borderColor: S.divider, color: S.textPrimary, background: "transparent" }}
          >
            Ana sayfa
          </Link>
        </div>

        <p className="mt-4 text-xs" style={{ color: S.textSecondary }}>
          Onay ve detaylar e-posta/panel üzerinden iletilecektir.
        </p>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
